import { useEffect } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { RouterProvider } from 'react-router-dom'
import { CssBaseline } from '@mui/material'
import * as Sentry from '@sentry/react'
import { SnackbarProvider } from 'notistack'
import { SnackbarCloseButton } from './components'
import { router } from './routes'
import { ThemeProvider } from './theme'

const App = () => {
  const { t } = useTranslation()

  useEffect(() => {
    const updateVariable = () => {
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      const vh = window.innerHeight * 0.01
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
    window.addEventListener('resize', updateVariable)
    updateVariable()
    return () => window.removeEventListener('resize', updateVariable)
  }, [])

  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h1>Something went wrong</h1>
          <p>
            {error instanceof Error
              ? error.message
              : 'An unknown error occurred'}
          </p>
          <button onClick={resetError}>Try again</button>
        </div>
      )}
    >
      <ThemeProvider>
        <CssBaseline />
        <SnackbarProvider
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'bottom',
          }}
          autoHideDuration={5000}
          action={(snackbarKey) => (
            <SnackbarCloseButton snackbarKey={snackbarKey} />
          )}
          preventDuplicate
        >
          <HelmetProvider>
            <Helmet>
              <title>{t('site.title')}</title>
            </Helmet>
            <RouterProvider router={router} />
          </HelmetProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  )
}

export default App
